import React from 'react';
import CigeerpCard from './cigefiCard';
import img1 from '../../../public/images/CIGEFI1.jpg';
import img2 from '../../../public/images/CIGEFI3.png';

const cigeerp = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">

      <div className="w-full lg:w-3/4 space-y-8">
        <CigeerpCard
          img={img1}
          title="CIGE FI - Contadores: La Solución Financiera para tu Estudio"
          description="CIGE-FI es la versión financiera de nuestro ERP, diseñada para optimizar la gestión de contadores y estudios contables. Con CIGE-FI, puedes llevar la contabilidad de tus clientes en tiempo real, ya sea que trabajes de forma presencial o remota a través de nuestra versión web.
Nuestra solución no solo cumple con las últimas exigencias tributarias, sino que también simplifica los procesos de auditoría documentaria. ¿Cómo? Permitiéndote adjuntar los documentos fuente (PDF, Word, Excel, TXT) a cada registro de compra o venta. De esta manera, todo está organizado y accesible, facilitando tu labor y asegurando la integridad de la información."
          items={[]}
        />
        <CigeerpCard
          img={img2}
          title="Características que Transforman tu Trabajo"
          description=""
          items={[
"Multiempresa y multiusuario: Gestiona la contabilidad de múltiples clientes de forma simultánea.",
"Automatización inteligente: Actualiza el tipo de cambio y consulta la validez de comprobantes de pago electrónico (CPE) y datos RUC de forma automática y en línea.",
"Gestión simplificada: Duplica y cancela documentos de compras y ventas con facilidad, ahorrando tiempo en tareas repetitivas.",
"Diferencia de cambio automática: Realiza los ajustes contables de forma precisa y sin esfuerzo.",
"Reportes en tiempo real: Genera estados financieros y sus notas de forma automática y en línea, sin procesos adicionales.",
"Importación masiva: Carga registros de compras y ventas directamente desde Excel, optimizando tu flujo de trabajo.",
"Preliquidación de impuestos: Obtén un cálculo preliminar de IGV y Renta para una mejor planificación fiscal."
          ]}
          reverse
        />
      </div>
    </div>
  );
};

export default cigeerp;
